import React from 'react';
import { useAppState } from '../../overmind';
import { hasRequiredFeatureFlag } from '../../library/helpers/feature-flags';
import { FeatureFlagType } from '../../enums/feature-flag-type';
import { ErrorPage } from '../error/error.page';
import { ClassicDashboardLayout } from './classic/classic.dashboard.layout';
import { FreemiumDashboardLayout } from '../freemium-feature/freemium-dashboard/freemium-dashboard.layout';

export function DashboardPage(): JSX.Element {
  const { companyVariables } = useAppState();
  if (hasRequiredFeatureFlag(companyVariables.featureFlags, [FeatureFlagType.FreemiumSignup])) {
    return <FreemiumDashboardLayout></FreemiumDashboardLayout>;
  } else if (hasRequiredFeatureFlag(companyVariables.featureFlags, [FeatureFlagType.ClassicFeatures])) {
    return <ClassicDashboardLayout></ClassicDashboardLayout>;
  }
  return <ErrorPage />;
}
